import { createAction, props } from '@ngrx/store';

const getImpMail = createAction('[Import] Get Import Mail', props<{ apiConstants: any; params: any }>());

const setImpMail = createAction('[Import] Set Import Mail', props<{ impMail: any }>());

const saveImpMail = createAction('[Import] save Import Mail', props<{ apiConstants: any; impMailData: any }>());

const deleteImpMail = createAction('[Import] delete Import Mail', props<{ apiConstants: any; ids: any }>());

export { getImpMail, setImpMail, saveImpMail, deleteImpMail };
